import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import awsconfig from './aws-exports';

import 'bulma/css/bulma.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'placeholder-loading/dist/css/placeholder-loading.min.css';

Amplify.configure(awsconfig);

Vue.use(AmplifyPlugin, AmplifyModules);

Vue.config.productionTip = process.env.NODE_ENV === 'development';

// Thank god for 
// https://dev.to/dabit3/how-to-build-production-ready-vue-authentication-23mk
new Vue({
  render: h => h(App),
  router,
}).$mount('#root');
